import { Projectcomment } from "@src/app/models/comment";
import {
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Projectmember } from "../projectportal/model/projectmember";
import { Task } from "@src/app/models/task";
import { ProjecttaskService } from "./service/projecttask.service";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { AuthorizationService } from "@src/app/helpers/authorization.service";
import { UieventhubService } from "@src/app/helpers/uieventhub/uieventhub.service";
import { Orgfile } from "./model/orgfile";
import "quill-mention/autoregister";
import { QuillEditorComponent } from "ngx-quill";
import { Router } from "@angular/router";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";
import { Project } from "@src/app/models/project";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { FormService } from "@src/app/components/forms/service/form.service";
import { FormResponseService } from "@src/app/components/forms/service/form-response.service";
import { FormRendererComponent } from "@src/app/components/forms/renderer/form-renderer.component";
import { FormTemplate } from "@src/app/components/forms/models/form.model";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ModalService } from "@src/app/helpers/modal.service";
import { TimeregistrationService } from "@src/app/helpers/timeregistration/timeregistration.service";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-projecttask",
  templateUrl: "./projecttask.component.html",
  styleUrls: ["./projecttask.component.css"],
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.2s 0.1s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.15s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("taskdoneAnimation", []),
  ],
})
export class ProjecttaskComponent implements OnInit, OnChanges {
  @ViewChild("target") targetElement: any;
  @Output() result: string;
  showDelete: boolean;
  @Output() arrowvalue: string;
  @Input() task: Task;
  @Input() projectMembers: Projectmember[];
  @Input() projectCustomerMembers: Projectmember[];
  @Input() commentsList: Projectcomment[];
  @Input() userview: boolean;
  @Output() taskstatetrack: boolean = false;
  @Output() taskanimationtype: string;
  @Input() @Output() listviewsetting: boolean;
  @Input() @Output() customermyview: boolean;
  @Input() @Output() customerourview: boolean;
  @ViewChildren("closetaskedit") closetaskedit: QueryList<ElementRef>;
  newComment: Projectcomment;
  organizationId: string;
  isCustomer: boolean;
  isCustomerTask: boolean;
  @Output() customerId: string;
  // Time tracking counter (timereg org module): loaded lazily, only once
  // the card is unfolded — not for every collapsed row in the list.
  timeregEnabled: boolean = false;
  timeSummaryLoaded: boolean = false;
  taskEstimateMinutes: number;
  taskLoggedMinutes: number;
  formIsValid: boolean;
  numberOfComments: number;
  myTask: boolean;
  showtaskdeletealert: boolean;
  numberOfFiles: number;
  filelistReloadTrigger: number = 0;
  @Output() fileToAdd: Orgfile;
  taskStatus: string;
  @ViewChild(QuillEditorComponent, { static: true })
  editor: QuillEditorComponent;
  acceptwarning: boolean;
  orgEdit: boolean;
  project: Project;
  errorMessage: string;
  showSpinner: boolean;
  showFormModalLoader = false;
  filelist: boolean = false;
  showFileListLoader: boolean = false;
  me: string;
  //private taskcomponent: ElementRef<HTMLElement>;

  @ViewChild("taskcomponent", { static: true }) taskcomponent: ElementRef;
  private readonly ptsrv = inject(ProjecttaskService);
  private readonly auth = inject(AuthorizationService);
  private readonly uieventhub = inject(UieventhubService);
  private readonly router = inject(Router);
  private readonly datastore = inject(DatastoreService);
  private readonly modalService = inject(ModalService);
  private readonly matDialog = inject(MatDialog);
  private readonly formService = inject(FormService);
  private readonly formResponseService = inject(FormResponseService);
  private readonly timeregSrv = inject(TimeregistrationService);
  // private ptsrv:ProjecttaskService,
  // private auth:AuthorizationService,
  // private taskcomponent: ElementRef<HTMLElement>,
  // private uieventhub: UieventhubService,
  // private router:Router,
  // private datastore: DatastoreService
  formats = [
    "background",
    "bold",
    "color",
    "font",
    "code",
    "italic",
    "link",
    "size",
    "strike",
    "script",
    "underline",
    "blockquote",
    "header",
    "indent",
    "list",
    "align",
    "direction",
    "code-block",
    "formula",
    // 'image'
    // 'video'
  ];
  modules = {
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      // onSelect: (item, insertItem) => {
      //   const editor = this.editor.quillEditor
      //   insertItem(item)
      //   // necessary because quill-mention triggers changes as 'api' instead of 'user'
      //   editor.insertText(editor.getLength() - 1, '', 'user')
      // },
      source: (searchTerm, renderList) => {
        const members = this.projectMembers.concat(this.projectCustomerMembers);
        const values = [];
        for (let index = 0; index < members.length; index++) {
          values.push({
            id: members[index].personId,
            value: members[index].fullname,
          });
        }

        if (searchTerm.length === 0) {
          renderList(values, searchTerm);
        } else {
          const matches = [];

          values.forEach((entry) => {
            if (
              entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
            ) {
              matches.push(entry);
            }
          });
          renderList(matches, searchTerm);
        }
      },
    },
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      ["link"],
    ],
  };

  constructor() { }
  newFile(nfil: Orgfile) {
    this.fileToAdd = nfil;
    this.numberOfFiles = this.numberOfFiles + 1;
    this.task.numberoffiles = this.numberOfFiles;
  }
  setTaskFilter(task: Task) {
    //console.log('Task filter',task);
    this.uieventhub.setshowchatcollapse(true);
    SessionHelper.setCurrentProject(task.projectId.split("_")[0]);
    let proj = this.datastore.projectList
      .getValue()
      .find((x) => x.projectId.split("_")[0] == task.projectId.split("_")[0]);

    SessionHelper.setCurrentProjectName(proj.title);
    SessionHelper.setCurrentProjectFull(JSON.stringify(proj));
    SessionHelper.setChatShow("chat");
    this.uieventhub.setCurrentProject(task.projectId.split("_")[0]);
    setTimeout(() => {
      this.uieventhub.setChatTask(task.taskId);
    }, 200);
  }
  setNumberOfFiles(num: number) {
    this.numberOfFiles = num;
    this.task.numberoffiles = num;
  }
  // ngOnInit() {
  //   this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tlist) => {
  //     if (
  //       this.task &&
  //       this.task.taskId != undefined &&
  //       this.task.taskId != "" &&
  //       tlist &&
  //       tlist.length > 0
  //     ) {
  //       //onsole.log('Task from datastore',this.task);
  //       let taskId = this.task.taskId.split("_")[0];
  //       let t = tlist.find(
  //         (x) => this.task.taskId && x.taskId.split("_")[0] == taskId
  //       );
  //       this.task = t;
  //       //console.log('Member list',this.projectMembers);
  //       if (this.task) {
  //         this.uieventhub.setCurrentProjectStateChange(this.task.projectId);
  //         this.orgEdit = this.auth.isAuthorized(
  //           "orgedit",
  //           SessionHelper.getChoosenOrg()
  //         );
  //         this.taskanimationtype = SessionHelper.getTaskAnimation();
  //         this.taskStatus = "onTrack";
  //         this.numberOfFiles = this.task.numberoffiles
  //           ? this.task.numberoffiles
  //           : 0;
  //         this.task.canEdit = false;
  //         this.myTask = false;
  //         this.customerId = this.datastore.projectList
  //           .getValue()
  //           .find((x) => x.projectId == this.task.projectId).customer;
  //         // this.ptsrv.getProject(this.task.projectId).pipe(untilDestroyed(this)).subscribe(proj => {
  //         //   this.customerId = proj.customer;
  //         // });
  //         if (SessionHelper.getCustomer()) {
  //           this.isCustomer = true;
  //         } else {
  //           this.isCustomer = false;
  //         }
  //         this.organizationId = SessionHelper.getChoosenOrg();
  //         this.showDelete = false;

  //         if (
  //           this.task.duedate == new Date().toISOString().substr(0, 10) &&
  //           this.task.taskstate != "Done"
  //         ) {
  //           this.taskStatus = "midt";
  //         }
  //         if (
  //           this.task.duedate < new Date().toISOString().substr(0, 10) &&
  //           this.task.taskstate != "Done"
  //         ) {
  //           this.taskStatus = "overdue";
  //         }
  //         this.newComment = new Projectcomment();
  //         this.arrowvalue = "expand_more";

  //         if (this.task.responsible == SessionHelper.getUserSub()) {
  //           this.task.canEdit = true;
  //           this.myTask = true;
  //         }
  //         if (this.auth.isAuthorized("orgedit", this.organizationId)) {
  //           this.task.canEdit = true;
  //         } else {
  //           this.task.canEdit = this.auth.isAuthorized(
  //             "taskedit",
  //             this.task.taskId.substr(0, 36)
  //           );
  //         }
  //         if (this.commentsList) {
  //           this.numberOfComments = this.commentsList.filter(
  //             (x) =>
  //               x.related_task.split("_")[0] ===
  //                 this.task.taskId.split("_")[0] && !x.parent_comment
  //           ).length;
  //         } else {
  //           this.numberOfComments = 0;
  //         }
  //       }
  //       //this.ngOnInit();

  //       this.orgEdit = this.auth.isAuthorized(
  //         "orgedit",
  //         SessionHelper.getChoosenOrg()
  //       );
  //       this.taskanimationtype = SessionHelper.getTaskAnimation();
  //       this.taskStatus = "onTrack";
  //       //this.numberOfFiles = 0;
  //       if (this.task) {
  //         this.task.canEdit = false;
  //         this.myTask = false;
  //         this.customerId = this.datastore.projectList
  //           .getValue()
  //           .find((x) => x.projectId == this.task.projectId).customer;
  //         // this.ptsrv.getProject(this.task.projectId).pipe(untilDestroyed(this)).subscribe(proj => {
  //         //   this.customerId = proj.customer;
  //         // });

  //         if (SessionHelper.getCustomer()) {
  //           this.isCustomer = true;
  //         } else {
  //           this.isCustomer = false;
  //         }
  //         this.organizationId = SessionHelper.getChoosenOrg();
  //         this.showDelete = false;

  //         if (
  //           this.task.duedate == new Date().toISOString().substr(0, 10) &&
  //           this.task.taskstate != "Done"
  //         ) {
  //           this.taskStatus = "midt";
  //         }
  //         if (
  //           this.task.duedate < new Date().toISOString().substr(0, 10) &&
  //           this.task.taskstate != "Done"
  //         ) {
  //           this.taskStatus = "overdue";
  //         }
  //         this.newComment = new Projectcomment();
  //         this.arrowvalue = "expand_more";

  //         if (this.task.responsible == SessionHelper.getUserSub()) {
  //           this.task.canEdit = true;
  //           this.myTask = true;
  //         }
  //         if (this.auth.isAuthorized("orgedit", this.organizationId)) {
  //           this.task.canEdit = true;
  //         } else {
  //           this.task.canEdit = this.auth.isAuthorized(
  //             "taskedit",
  //             this.task.taskId.substr(0, 36)
  //           );
  //         }
  //         if (this.commentsList) {
  //           this.numberOfComments = this.commentsList.filter(
  //             (x) =>
  //               x.related_task.split("_")[0] ===
  //                 this.task.taskId.split("_")[0] && !x.parent_comment
  //           ).length;
  //         } else {
  //           this.numberOfComments = 0;
  //         }
  //       }
  //     }
  //   });
  //   this.projectCustomerMembers = [];
  //   this.datastore.customersUsers
  //     .getValue()
  //     .filter((cu) => cu.customerId.split("_")[0] == this.customerId)
  //     .forEach((cu) => {
  //       this.projectCustomerMembers.push({
  //         userId: cu.userId,
  //         projectId: this.task.projectId,
  //         personId: cu.userId.split("_")[0],
  //         fullname: cu.fullname,
  //         email: cu.email,
  //         phone: cu.phone,
  //         im: "",
  //         iscustomer: true,
  //       });
  //     });

  //   this.updateResp();
  // }

  ngOnInit() {
    this.me = SessionHelper.getUserSub();
    this.datastore.taskList$.pipe(untilDestroyed(this)).subscribe((tlist) => {
      if (!this.task?.taskId || !tlist?.length) return;

      const taskId = this.task.taskId.split("_")[0];
      const matchedTask = tlist.find(
        (x) => x.taskId.split("_")[0] === taskId
      );
      if (!matchedTask) return;

      this.applyTaskState(matchedTask);
    });

    this.applyTaskState(this.task);
    this.updateResp();
  }

  updateHeight(show: boolean) {
    if (show) {
      // Here you can use the height!
      setTimeout(() => {
        this.result = this.targetElement.nativeElement.offsetHeight;
        //console.log(this.result);
      }, 500);
    } else {
      this.result = "40";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.commentsList && changes.commentsList.currentValue) {
      this.commentsList = changes.commentsList.currentValue;
      if (this.task?.taskId) {
        const currentTaskBaseId = this.getTaskBaseId(this.task.taskId);
        this.numberOfComments = this.commentsList.filter(
          (x) =>
            this.getTaskBaseId(x?.related_task) === currentTaskBaseId &&
            !x.parent_comment
        ).length;
      }
    }
    // if(changes.projectCustomerMembers && changes.projectCustomerMembers.currentValue){
    //   this.projectCustomerMembers = changes.projectCustomerMembers.currentValue;
    //Update task on changes
    if (changes.task && changes.task.currentValue) {
      this.task = changes.task.currentValue;
      this.applyTaskState(this.task);
    }
    this.updateResp();
    // }
  }

  private applyTaskState(task: Task) {
    if (!task?.taskId) {
      return;
    }

    this.task = task;
    const { projectId, duedate, taskstate, responsible, taskId: fullTaskId } = this.task;
    const taskId = fullTaskId.split("_")[0];

    this.uieventhub.setCurrentProjectStateChange(projectId);
    this.organizationId = SessionHelper.getChoosenOrg();
    this.orgEdit = this.auth.isAuthorized("orgedit", this.organizationId);
    this.taskanimationtype = SessionHelper.getTaskAnimation();
    this.taskStatus = "onTrack";
    const incomingFileCount = this.task.numberoffiles ?? 0;
    if (incomingFileCount !== this.numberOfFiles) {
      this.numberOfFiles = incomingFileCount;
      this.filelistReloadTrigger++;
    }

    const project = this.datastore.projectList.getValue().find(p => p.projectId === projectId);
    if (project) {
      this.customerId = project.customer;
    }

    this.isCustomer = !!SessionHelper.getCustomer();
    this.timeregEnabled = SessionHelper.hasModule("timereg") && !this.isCustomer;
    this.showDelete = false;

    const today = new Date().toISOString().substr(0, 10);
    if (duedate === today && taskstate !== "Done") {
      this.taskStatus = "midt";
    } else if (duedate < today && taskstate !== "Done") {
      this.taskStatus = "overdue";
    }

    this.newComment = new Projectcomment();
    this.arrowvalue = "expand_more";

    if (responsible == this.me) {
      this.task.canEdit = true;
      this.myTask = true;
    } else {
      this.task.canEdit = false;
      this.myTask = false;
      this.task.canEdit = this.auth.isAuthorized("orgedit", this.organizationId)
        || this.auth.isAuthorized("taskedit", fullTaskId.substring(0, 36));
    }

    this.numberOfComments = this.commentsList
      ? this.commentsList.filter(
        (x) =>
          this.getTaskBaseId(x?.related_task) === taskId &&
          !x.parent_comment
      ).length
      : 0;

    this.projectCustomerMembers = this.datastore.customersUsers
      .getValue()
      .filter((cu) => cu.customerId.split("_")[0] === this.customerId)
      .map((cu) => ({
        userId: cu.userId,
        projectId,
        personId: cu.userId.split("_")[0],
        fullname: cu.fullname,
        email: cu.email,
        phone: cu.phone,
        im: "",
        iscustomer: true,
      }));
  }

  private getTaskBaseId(taskRef?: string): string {
    return (taskRef || '').split('_')[0];
  }

  updateResp() {
    if (!this.userview) {
      //console.log('Task responsible',this.task.responsible);
      //console.log('Project members',this.projectCustomerMembers);
      if (
        this.projectCustomerMembers?.find(
          (x) => x.personId == this.task.responsible
        ) != undefined
      ) {
        this.isCustomerTask = true;
      } else {
        this.isCustomerTask = false;
      }
    }
    this.uieventhub.removeLoader("project");
    this.uieventhub.removeLoader("projectportal_tasks");
    this.uieventhub.removeLoader("projectportal_stages");
    this.uieventhub.removeLoader("projectportal_comments");
    this.uieventhub.removeLoader("projprojectportal_customermembers");
  }
  clickEdit(task: Task) {
    //this.modalTask = task;
    this.modalService.open("taskeditmodal");
    let t = JSON.parse(JSON.stringify(task));
    this.uieventhub.setEditTask(t);

    //console.log('Task edit clicked');
    //console.log(this.modalTask);
  }
  taskDone(task: Task) {
    this.taskstatetrack = true;
    task.taskstate = "Done";

    //console.log(task);
    this.ptsrv
      .taskDone(task)
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        //Newversion id
        this.task.taskId = result;
        //Update UI
        this.task.taskstate = "Done";
        //this.uieventhub.setCurrentProjectStateChange(this.task.projectId);
        //this.datastore.updateTask(this.task);
        //this.ptsrv.generateStats(this.task.projectId).pipe(untilDestroyed(this)).subscribe(() => {});
      });
  }

  openFormModal(task: Task) {
    const taskBaseId = (task?.taskId || '').split('_')[0];
    const cachedTask = [
      ...(this.datastore.taskList.getValue() || []),
      ...(this.datastore.customerTasks.getValue() || []),
      ...(this.datastore.lightTaskList.getValue() || []),
    ].find((t) => (t?.taskId || '').split('_')[0] === taskBaseId);

    const taskAny = task as any;
    const cachedTaskAny = (cachedTask || {}) as any;

    const resolvedFormTemplateId = task.formTemplateId
      || taskAny.form_template_id
      || taskAny.templateId
      || taskAny.template_id
      || cachedTask?.formTemplateId
      || cachedTaskAny.form_template_id
      || cachedTaskAny.templateId
      || cachedTaskAny.template_id;

    const resolvedFormTemplateName = task.formTemplateName
      || taskAny.form_template_name
      || taskAny.templateName
      || taskAny.template_name
      || cachedTask?.formTemplateName
      || cachedTaskAny.form_template_name
      || cachedTaskAny.templateName
      || cachedTaskAny.template_name;

    const rawTemplateVersion = task.formTemplateVersion
      ?? taskAny.form_template_version
      ?? taskAny.templateVersion
      ?? taskAny.template_version
      ?? cachedTask?.formTemplateVersion
      ?? cachedTaskAny.form_template_version
      ?? cachedTaskAny.templateVersion
      ?? cachedTaskAny.template_version;

    const resolvedFormTemplateVersion = rawTemplateVersion === undefined || rawTemplateVersion === null || rawTemplateVersion === ''
      ? undefined
      : Number(rawTemplateVersion);

    const resolvedTask = {
      ...task,
      formTemplateId: resolvedFormTemplateId,
      formTemplateVersion: resolvedFormTemplateVersion,
      formTemplateName: resolvedFormTemplateName,
    } as Task;

    console.log('openFormModal called with task:', {
      taskId: resolvedTask.taskId,
      formTemplateId: resolvedTask.formTemplateId,
      formTemplateVersion: resolvedTask.formTemplateVersion,
      tasktype: resolvedTask.tasktype
    });

    if (!resolvedTask.formTemplateId || !resolvedTask.formTemplateVersion) {
      console.error('Task missing form template reference');
      return;
    }

    this.showFormModalLoader = true;

    // Extract base template ID (strip version suffix if present, e.g., "uuid_v2" -> "uuid")
    const baseTemplateId = resolvedTask.formTemplateId.replace(/_v\d+$/, '');
    console.log('Base template ID after stripping version:', baseTemplateId);

    // Fetch the form template
    this.formService.getTemplate(this.organizationId, baseTemplateId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (templates: FormTemplate[]) => {
          console.log('Form templates received:', templates);
          console.log('Looking for templateId:', resolvedTask.formTemplateId, 'version:', resolvedTask.formTemplateVersion);

          // Prefer the exact version linked to the task; fallback to first
          const template = templates.find(t => t.version === resolvedTask.formTemplateVersion) || templates[0];
          if (!template) {
            console.error('Form template not found. Templates array:', templates);
            console.error('Task references templateId:', resolvedTask.formTemplateId, 'version:', resolvedTask.formTemplateVersion);
            alert(`Form template not found. The form linked to this task may have been deleted or is not accessible. Template ID: ${baseTemplateId}`);
            this.showFormModalLoader = false;
            return;
          }

          // Normalize tabs in case API returns stringified tabs
          const normalizedTemplate: FormTemplate = {
            ...template,
            // Ensure id is present even if backend returned templateId
            id: (template as any).id || (template as any).templateId || baseTemplateId,
            tabs: Array.isArray((template as any).tabs)
              ? (template as any).tabs
              : typeof (template as any).tabs === 'string'
                ? JSON.parse((template as any).tabs)
                : []
          };

          // Fetch existing response if available
          this.formResponseService.getTaskResponses(
            template.id,
            this.organizationId,
            resolvedTask.projectId,
            resolvedTask.taskId
          )
            .pipe(untilDestroyed(this))
            .subscribe({
              next: (responses) => {
                const existingResponse = responses?.length > 0 ? responses[0] : undefined;
                console.log('responses list ', responses);
                this.showFormModalLoader = false;

                const dialogRef = this.matDialog.open(
                  FormRendererComponent,
                  this.buildFormDialogConfig(normalizedTemplate, resolvedTask, existingResponse)
                );

                dialogRef.afterClosed()
                  .pipe(untilDestroyed(this))
                  .subscribe(result => {
                    if (result?.taskCompleted) {
                      // Task was completed via form submission
                      this.task.taskstate = 'Done';
                      this.task.taskId = result.newTaskId || this.task.taskId;
                    }
                  });
              },
              error: (err) => {
                console.error('Error loading form response:', err);
                // Still open the form even if no draft exists
                this.showFormModalLoader = false;

                this.matDialog.open(
                  FormRendererComponent,
                  this.buildFormDialogConfig(normalizedTemplate, resolvedTask)
                );
              }
            });
        },
        error: (err) => {
          console.error('Error loading form template:', err);
          this.showFormModalLoader = false;
        }
      });
  }

  private buildFormDialogConfig(
    template: FormTemplate,
    task: Task,
    existingResponse?: any
  ): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '95vw';
    dialogConfig.height = '95vh';
    dialogConfig.maxWidth = '1400px';
    dialogConfig.panelClass = ['form-modal-xl'];
    dialogConfig.disableClose = false;
    dialogConfig.data = {
      template,
      existingResponse,
      organizationId: this.organizationId,
      projectId: task.projectId,
      taskId: task.taskId,
      task: task
    };

    return dialogConfig;
  }
  taskUndone(task: Task) {
    this.taskstatetrack = true;
    task.taskstate = "Undone";
    //console.log(task);
    this.ptsrv
      .taskUndone(task)
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        //Newversion id
        this.task.taskId = result;
        //Update UI
        this.task.taskstate = "Undone";
        //this.uieventhub.setCurrentProjectStateChange(this.task.projectId);
        //this.ptsrv.generateStats(this.task.projectId).pipe(untilDestroyed(this)).subscribe(() => {});
      });
  }
  // saveTask(){
  //   if(!this.modalTask.title || !this.modalTask.duedate || !this.modalTask.startdate || !this.modalTask.responsible){
  //     this.errorMessage = "modalvalidation.requiredfieldmissing";
  //   }else{
  //     this.showSpinner = true;
  //     if(!this.modalTask.description){
  //       this.modalTask.description = " ";
  //     }
  //     //quill br temp fix
  //     this.modalTask.description = this.modalTask.description.replace(new RegExp("<p></p>",'g'),"<br>");
  //     //quill br temp fix end

  //   this.taskStatus = "onTrack";
  //   if(this.modalTask.duedate == new Date().toISOString().substring(0,10) && this.task.taskstate != "Done"){
  //     this.taskStatus = "midt"
  //   }
  //   if(this.modalTask.duedate < new Date().toISOString().substring(0,10) && this.task.taskstate != "Done"){
  //     this.taskStatus = "overdue"
  //   }
  //   this.ptsrv.saveTask(this.modalTask).subscribe(result => {
  //     //Newversion id
  //     this.task.taskId = result;
  //     this.showSpinner = false;
  //     //Update UI
  //     this.closeModal('taskmodal'+this.modalTask.taskId);
  //     // this.auth.refreshPersonAuth(SessionHelper.getUserSub());
  //     // this.task.canEdit = true;
  //     // this.updateResp();
  //     // sessionStorage.setItem(('task_'+this.task.taskId),JSON.stringify(this.task));

  //     //this.uieventhub.setCurrentProjectStateChange(this.task.projectId);
  //     //this.ptsrv.generateStats(this.task.projectId).pipe(untilDestroyed(this)).subscribe(proj => {

  //    // });
  //   })
  // }
  // }
  // closeModal(taskHTMLId:string){
  //  //console.log('Close modal '+taskHTMLId);
  //   this.modalService.close(taskHTMLId);
  //   this.modalTask = new Task;
  // }

  deleteTask(task: Task) {
    this.ptsrv
      .deleteTask(task)
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        //Newversion id
        //this.task.taskId = result;
        // this.datastore.deleteTask(task.taskId);
        // this.ptsrv.generateStats(task.projectId).pipe(untilDestroyed(this)).subscribe(() => {
        //   this.uieventhub.setRemoveTask(task);

        //   this.taskcomponent.nativeElement.remove();
        // });
        this.taskcomponent.nativeElement.remove();
        this.showTaskDeleteAlert()
      });
  }
  DeleteConfirm() {
    this.showDelete = !this.showDelete;
  }
  toggleCollapseArrow() {
    this.task.show = !this.task.show;
    if (this.task.show) {
      this.loadTimeSummary();
    }
    //console.log('task responsible',this.task.responsible);
    if (this.arrowvalue == "expand_more") {
      this.arrowvalue = "keyboard_arrow_up";
      //this.updateHeight(true);
      // if (this.auth.isAuthorized("orgedit", this.organizationId)) {
      //   this.task.canEdit = true;
      // } else {
      //   this.task.canEdit = this.auth.isAuthorized(
      //     "taskedit",
      //     this.task.taskId.split('_')[0]
      //   );
      // }
    } else {
      this.taskstatetrack = false;
      //this.updateHeight(false);
      this.arrowvalue = "expand_more";
    }
  }

  loadTimeSummary() {
    if (!this.timeregEnabled || this.timeSummaryLoaded || !this.task?.taskId || !this.task?.projectId) {
      return;
    }
    this.timeregSrv.getTaskTimeSummary(this.task.projectId, this.task.taskId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (summary) => {
          this.taskEstimateMinutes = summary.estimateMinutes;
          this.taskLoggedMinutes = summary.loggedMinutes;
          this.timeSummaryLoaded = true;
        },
        error: (err) => console.error("[Projecttask] Failed to load time summary", err),
      });
  }

  // Up to 2 decimals, trailing zeros trimmed, comma as the decimal mark.
  // 1 decimal wasn't enough: a quarter hour (0.25) would round to "0,3".
  private minutesToHoursLabel(minutes: number): string {
    const hours = Math.round((minutes / 60) * 100) / 100;
    return hours.toFixed(2).replace(/\.?0+$/, '').replace(".", ",");
  }

  // "1/2,5" — logged over estimated, only once there's something to show.
  timeCounterLabel(): string | null {
    if (this.taskEstimateMinutes === undefined || !this.timeSummaryLoaded) {
      return null;
    }
    return this.minutesToHoursLabel(this.taskLoggedMinutes) + "/" + this.minutesToHoursLabel(this.taskEstimateMinutes);
  }

  timeCounterTooltip(): string {
    return this.minutesToHoursLabel(this.taskLoggedMinutes) + " h logged / "
      + this.minutesToHoursLabel(this.taskEstimateMinutes) + " h estimated";
  }

  saveComment() {
    //this.newComment.parent_comment = "01527e70-7b91-11eb-a42e-87af83786f1b";
    this.newComment.projectId = SessionHelper.getCurrentProject();
    this.newComment.comment_type = "organization"; //TODO differenciate between customers and org users and set accordingly
    this.newComment.related_task = this.task.taskId;
    this.newComment.commentvisibility = this.task.taskvisibility;
    this.ptsrv
      .saveComment(this.newComment)
      .pipe(untilDestroyed(this))
      .subscribe((pc) => {
        this.newComment.commentId = pc;
        // this.commentsList.push(this.newComment);
        // //console.log(this.commentsList);
        this.newComment = new Projectcomment();
        this.uieventhub.setProjectComments(this.newComment.projectId);
      });
  }

  navigate(t: Task) {
    SessionHelper.setCurrentProject(t.projectId);
    this.uieventhub.setCurrentProject(t.projectId);
    this.router.navigate(["/portal/project/" + t.projectId]);
  }
  ngAfterViewInit() {
    this.uieventhub.removeLoader("projectportal_tasks");
    this.uieventhub.removeLoader("projectportal_stages");
    this.uieventhub.removeLoader("projectportal");
  }

  togglefilelist() {
    this.filelist = !this.filelist;
    if (this.filelist) {
      this.showFileListLoader = true;
    }
  }
  //stop loader when filelist is loaded
  filelistLoaded() {
    this.showFileListLoader = false;
  }
  showTaskDeleteAlert() {
    this.showtaskdeletealert = true;
    setTimeout(() => {
      this.showtaskdeletealert = false;
    }, 2000);
  }
}
